import { scheduledMessageType, roles } from 'appConstants';

const { CANDIDATE, CAMPAIGN } = scheduledMessageType;

export const getRecipientType = (recipient) => (recipient.fullName ? CANDIDATE : CAMPAIGN);

export const getCandidateCount = (sendToList) => {
  let count = 0;

  sendToList.forEach((recipient) => {
    const type = recipient.type ? recipient.type : getRecipientType(recipient);

    count += type === CANDIDATE ? 1 : recipient.candidateCount;
  });

  return count;
};

export const getSnackbarMessage = ({ t, scheduleMessage, sendNow }) => {
  const { sendToList } = scheduleMessage;
  const totalRecepients = getCandidateCount(sendToList);

  if (totalRecepients === 1) {
    return sendNow
      ? t(
          'your_message_has_been_sent_singular',
          'Your message has been sent for delivery to 1 recipient',
        )
      : t(
          'your_message_has_been_queued_singular',
          'Your message has been queued for delivery to 1 recipient',
        );
  }

  return sendNow
    ? t(
        'your_message_has_been_sent_plural',
        'Your message has been sent for delivery to {{number}} recipients',
        { number: totalRecepients },
      )
    : t(
        'your_message_has_been_queued_plural',
        'Your message has been queued for delivery to {{number}} recipients',
        { number: totalRecepients },
      );
};

export const setGraphData = ({ role, uniqMessageReceive, userMessageData, setMetricGraph }) => {
  if (role !== roles.USER && uniqMessageReceive) {
    uniqMessageReceive.data.forEach((metric) => {
      setMetricGraph(metric);
    });
  }
  if (role === roles.USER && userMessageData) {
    userMessageData.data.forEach((metric) => {
      setMetricGraph(metric);
    });
  }
};
